// admin.routes.ts

import NavigationLayout from '../../Layouts/NavigationLayout';
import { Navigation } from '../../utils';
import AdminBasePage from './AdminBasePage';

import OrdersList from './modules/orders/scenes/OrdersList';
import PodList from './modules/pods/scenes/PodList';
import PodDashboard from './modules/pods/scenes/PodDashboard';
import PhysicalProductList from './modules/physicalProducts/scenes/PhysicalProductList';
import SubscriptionList from './modules/subscriptions/scenes/SubscriptionList';
import CommissionList from './modules/commissions/scenes/CommissionList';
import CompPlanReport from './modules/commissions/scenes/CompPlanReport';
import IntegrationsList from './modules/integrations/scenes/IntegrationsList';
import UsersList from './modules/users/scenes/UsersList';
import LpsPage from './modules/lps/scenes/LpsPage';
import AdminSalesFunnelDashboard from './modules/salesFunnel/scenes/AdminSalesFunnelDashboard';

export const adminRoutes = [
    {
        exact: false,
        layout: NavigationLayout,
        path: '/admin',
        component: AdminBasePage,
        private: true,
        primaryNavigation: Navigation.ADMIN,
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/orders',
        component: OrdersList,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_ORDERS,
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/pods/dashboard',
        component: PodDashboard,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_PODS,
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/pods',
        component: PodList,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_PODS,
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/products',
        component: PhysicalProductList,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_PRODUCTS,
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/subscriptions',
        component: SubscriptionList,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_SUBSCRIPTIONS,
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/commissions',
        component: CommissionList,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_COMMISSIONS,
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/comp-plan',
        component: CompPlanReport,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_COMP_PLAN,
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/integrations',
        component: IntegrationsList,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_INTEGRATIONS,
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/users',
        component: UsersList,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_USERS,
        pageTitle: 'Users',
    },
    {
        exact: true,
        layout: NavigationLayout,
        path: '/admin/sales-funnel',
        component: AdminSalesFunnelDashboard,
        private: true,
        primaryNavigation: Navigation.ADMIN,
    },
    {
        exact: false,
        layout: NavigationLayout,
        path: '/admin/lps',
        component: LpsPage,
        private: true,
        primaryNavigation: Navigation.ADMIN,
    },
    {
        exact: false,
        layout: NavigationLayout,
        path: '/admin/surveys',
        component: AdminBasePage,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_SURVEYS,
    },
    {
        exact: false,
        layout: NavigationLayout,
        path: '/admin/whats-new',
        component: AdminBasePage,
        private: true,
        primaryNavigation: Navigation.ADMIN,
        secondaryNavigation: Navigation.ADMIN_WHATS_NEW,
    },
];
